import React, { useState, forwardRef } from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";
import Slide from "@mui/material/Slide";
import { TransitionProps } from "@mui/material/transitions";
import {
  Typography,
  TextField,
  MenuItem,
  Select,
  InputLabel,
  Avatar,
  Box,
  TextareaAutosize,

} from "@mui/material";
import FormControl from "@mui/material/FormControl";
import { members } from "../../constants";
import IMembers from "models/Members";
import IFeedbackForm from "models/FeedbackForm";

const Transition = forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<any, any>;
  },
  ref: React.Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const FeedbackForm: React.FC<IFeedbackForm> = ({ formOpen, handleFeedbackFormClose }) => {
  const [selectedMember, setSelectedMember] = useState(null);
  const [title, setTitle] = useState("");
//   const [member, setMember] = useState<IMembers | null>(null);
  const [feedbackDescription, setFeedbackDescription] = useState("");

  const handleChange = (event: any) => {
    setSelectedMember(event.target.value);
  };

  const handleCancel = () => {
    setSelectedMember(null);
    setTitle("");
    setFeedbackDescription("");
    handleFeedbackFormClose();
  };

  const handleSubmit = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    setSelectedMember(null);
    setTitle("");
    setFeedbackDescription("");
    handleFeedbackFormClose();
  };

  const renderMemberOption = ({ id, name, avatar }: IMembers) => (
    <MenuItem key={id} value={id}>
      <Box display="flex" alignItems="center">
        <Avatar src={avatar} alt={name} />
        <Box ml={1}>{name}</Box>
      </Box>
    </MenuItem>
  );

  return (
    <Dialog
      open={formOpen}
      onClose={handleCancel}
      TransitionComponent={Transition}
      keepMounted
      maxWidth="sm"
      fullWidth
      aria-describedby="alert-dialog-slide-description"
    >
      <DialogTitle>
        <Typography variant="h4" sx={{ fontSize: "24px", color: "#146ED2", fontWeight: 800 }}>
          Create Feedback
        </Typography>
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          <Typography variant="h4" sx={{ fontSize: "18px", color: "#146ED2", fontWeight: 800 }}>
            General information
          </Typography>
        </DialogContentText>
        <TextField
          autoFocus={true}
          margin="normal"
          id="title"
          label="Title"
          placeholder="Enter Feedback Title"
          fullWidth
          value={title}
          onChange={(e) => setTitle(e.target.value)}
        />
        <Typography
          variant="h4"
          sx={{ fontSize: "14px", color: "#146ED2", fontWeight: 800, mt: 1 }}
        >
          Select Member
        </Typography>
        <Box sx={{ mt: 1 }}>
          <FormControl sx={{ minWidth: 120 }}>
            <InputLabel id="demo-simple-select-label">Options</InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={selectedMember}
              label="Options"
              onChange={handleChange}
            >
              {members.map(renderMemberOption)}
            </Select>
          </FormControl>
        </Box>
        <Typography
          variant="h4"
          sx={{
            fontSize: "14px",
            color: "#146ED2",
            fontWeight: 800,
            mt: 2,
            mb: 1,
          }}
        >
          Feedback Description
        </Typography>
        <TextareaAutosize
          minRows={4}
          placeholder="Enter feedback description"
          value={feedbackDescription}
          onChange={(e) => setFeedbackDescription(e.target.value)}
          style={{
            width: "100%",
            padding: "8px",
            fontFamily: "inherit",
            fontSize: "16px",
            color: "gray",
            border: "1.8px solid lightgrey",
          }}
        />
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" onClick={handleCancel}>
          Cancel
        </Button>
        <Button variant="contained" onClick={handleSubmit}>
          Submit
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default FeedbackForm;
